"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/transfer-status.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Ftransfer-status.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferStatusTransferFailureLimitExceeded = exports.TransferStatusTransferFailureInsufficientFunds = exports.TransferStatusTransferFailure = exports.TransferStatusTransferPendingPaymentRequires3Ds = exports.TransferStatusTransferPendingPaymentSubmitted = exports.TransferStatusTransferPendingNonStepCounterparty = exports.TransferStatusTransferPendingManualReview = exports.TransferStatusTransferPending = exports.TransferStatusTransferSuccess = exports.TransferStatus = void 0;
const amount_1 = require("../common/amount");
const transaction_error_code_1 = require("../ledger/transaction-error-code");
const transaction_limit_error_1 = require("../ledger/transaction-limit-error");
const transfer_request_1 = require("./transfer-request");
const protobufPackage = 'com.step.transfer.proto';
function createBaseTransferStatus() {
    return { success: undefined, pending: undefined, failure: undefined };
}
exports.TransferStatus = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.success)) {
            message.success = exports.TransferStatusTransferSuccess.fromJSON(object.success);
        }
        if (isSet(object.pending)) {
            message.pending = exports.TransferStatusTransferPending.fromJSON(object.pending);
        }
        if (isSet(object.failure)) {
            message.failure = exports.TransferStatusTransferFailure.fromJSON(object.failure);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.success !== undefined) {
            obj.success = exports.TransferStatusTransferSuccess.toJSON(message.success);
        }
        if (message.pending !== undefined) {
            obj.pending = exports.TransferStatusTransferPending.toJSON(message.pending);
        }
        if (message.failure !== undefined) {
            obj.failure = exports.TransferStatusTransferFailure.toJSON(message.failure);
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatus.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatus();
        message.success = (object.success !== undefined && object.success !== null)
            ? exports.TransferStatusTransferSuccess.fromPartial(object.success)
            : undefined;
        message.pending = (object.pending !== undefined && object.pending !== null)
            ? exports.TransferStatusTransferPending.fromPartial(object.pending)
            : undefined;
        message.failure = (object.failure !== undefined && object.failure !== null)
            ? exports.TransferStatusTransferFailure.fromPartial(object.failure)
            : undefined;
        return message;
    },
};
function createBaseTransferStatusTransferSuccess() {
    return { paymentId: '' };
}
exports.TransferStatusTransferSuccess = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferSuccess.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatusTransferSuccess();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseTransferStatusTransferPending() {
    return {
        paymentId: '',
        manualReview: undefined,
        nonStepCounterparty: undefined,
        paymentSubmitted: undefined,
        requires3DS: undefined,
    };
}
exports.TransferStatusTransferPending = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        if (isSet(object.manualReview)) {
            message.manualReview = exports.TransferStatusTransferPendingManualReview.fromJSON(object.manualReview);
        }
        if (isSet(object.nonStepCounterparty)) {
            message.nonStepCounterparty = exports.TransferStatusTransferPendingNonStepCounterparty.fromJSON(object.nonStepCounterparty);
        }
        if (isSet(object.paymentSubmitted)) {
            message.paymentSubmitted = exports.TransferStatusTransferPendingPaymentSubmitted.fromJSON(object.paymentSubmitted);
        }
        if (isSet(object.requires3DS)) {
            message.requires3DS = exports.TransferStatusTransferPendingPaymentRequires3Ds.fromJSON(object.requires3DS);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.manualReview !== undefined) {
            obj.manualReview = exports.TransferStatusTransferPendingManualReview.toJSON(message.manualReview);
        }
        if (message.nonStepCounterparty !== undefined) {
            obj.nonStepCounterparty = exports.TransferStatusTransferPendingNonStepCounterparty.toJSON(message.nonStepCounterparty);
        }
        if (message.paymentSubmitted !== undefined) {
            obj.paymentSubmitted = exports.TransferStatusTransferPendingPaymentSubmitted.toJSON(message.paymentSubmitted);
        }
        if (message.requires3DS !== undefined) {
            obj.requires3DS = exports.TransferStatusTransferPendingPaymentRequires3Ds.toJSON(message.requires3DS);
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferPending.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatusTransferPending();
        message.paymentId = object.paymentId ?? '';
        message.manualReview = (object.manualReview !== undefined && object.manualReview !== null)
            ? exports.TransferStatusTransferPendingManualReview.fromPartial(object.manualReview)
            : undefined;
        message.nonStepCounterparty =
            (object.nonStepCounterparty !== undefined && object.nonStepCounterparty !== null)
                ? exports.TransferStatusTransferPendingNonStepCounterparty.fromPartial(object.nonStepCounterparty)
                : undefined;
        message.paymentSubmitted =
            (object.paymentSubmitted !== undefined && object.paymentSubmitted !== null)
                ? exports.TransferStatusTransferPendingPaymentSubmitted.fromPartial(object.paymentSubmitted)
                : undefined;
        message.requires3DS = (object.requires3DS !== undefined && object.requires3DS !== null)
            ? exports.TransferStatusTransferPendingPaymentRequires3Ds.fromPartial(object.requires3DS)
            : undefined;
        return message;
    },
};
function createBaseTransferStatusTransferPendingManualReview() {
    return {};
}
exports.TransferStatusTransferPendingManualReview = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferPendingManualReview.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseTransferStatusTransferPendingManualReview();
        return message;
    },
};
function createBaseTransferStatusTransferPendingNonStepCounterparty() {
    return { request: transfer_request_1.TransferRequest.fromPartial({}) };
}
exports.TransferStatusTransferPendingNonStepCounterparty = {
    fromJSON(object) {
        const message = {
            request: isSet(object.request)
                ? transfer_request_1.TransferRequest.fromJSON(object.request)
                : transfer_request_1.TransferRequest.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.request !== undefined) {
            obj.request = transfer_request_1.TransferRequest.toJSON(message.request);
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferPendingNonStepCounterparty.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatusTransferPendingNonStepCounterparty();
        message.request = (object.request !== undefined && object.request !== null)
            ? transfer_request_1.TransferRequest.fromPartial(object.request)
            : transfer_request_1.TransferRequest.fromPartial({});
        return message;
    },
};
function createBaseTransferStatusTransferPendingPaymentSubmitted() {
    return { etaMs: '0' };
}
exports.TransferStatusTransferPendingPaymentSubmitted = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.etaMs)) {
            message.etaMs = globalThis.String(object.etaMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.etaMs !== undefined && message.etaMs !== '0') {
            obj.etaMs = message.etaMs;
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferPendingPaymentSubmitted.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatusTransferPendingPaymentSubmitted();
        message.etaMs = object.etaMs ?? '0';
        return message;
    },
};
function createBaseTransferStatusTransferPendingPaymentRequires3Ds() {
    return { authorizationUrl: '', returnUrl: '' };
}
exports.TransferStatusTransferPendingPaymentRequires3Ds = {
    fromJSON(object) {
        const message = {
            authorizationUrl: isSet(object.authorizationUrl)
                ? globalThis.String(object.authorizationUrl)
                : '',
            returnUrl: isSet(object.returnUrl) ? globalThis.String(object.returnUrl) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.authorizationUrl !== '') {
            obj.authorizationUrl = message.authorizationUrl;
        }
        if (message.returnUrl !== '') {
            obj.returnUrl = message.returnUrl;
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferPendingPaymentRequires3Ds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatusTransferPendingPaymentRequires3Ds();
        message.authorizationUrl = object.authorizationUrl ?? '';
        message.returnUrl = object.returnUrl ?? '';
        return message;
    },
};
function createBaseTransferStatusTransferFailure() {
    return {
        error: transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE,
        insufficientFunds: undefined,
        limitExceeded: undefined,
        paymentId: '',
    };
}
exports.TransferStatusTransferFailure = {
    fromJSON(object) {
        const message = {
            error: isSet(object.error)
                ? (0, transaction_error_code_1.transactionErrorCodeFromJSON)(object.error)
                : transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE,
        };
        if (isSet(object.insufficientFunds)) {
            message.insufficientFunds = exports.TransferStatusTransferFailureInsufficientFunds.fromJSON(object.insufficientFunds);
        }
        if (isSet(object.limitExceeded)) {
            message.limitExceeded = exports.TransferStatusTransferFailureLimitExceeded.fromJSON(object.limitExceeded);
        }
        if (isSet(object.paymentId)) {
            message.paymentId = globalThis.String(object.paymentId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.error !== transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE) {
            obj.error = (0, transaction_error_code_1.transactionErrorCodeToJSON)(message.error);
        }
        if (message.insufficientFunds !== undefined) {
            obj.insufficientFunds = exports.TransferStatusTransferFailureInsufficientFunds.toJSON(message.insufficientFunds);
        }
        if (message.limitExceeded !== undefined) {
            obj.limitExceeded = exports.TransferStatusTransferFailureLimitExceeded.toJSON(message.limitExceeded);
        }
        if (message.paymentId !== undefined && message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferFailure.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatusTransferFailure();
        message.error = object.error ?? transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE;
        message.insufficientFunds =
            (object.insufficientFunds !== undefined && object.insufficientFunds !== null)
                ? exports.TransferStatusTransferFailureInsufficientFunds.fromPartial(object.insufficientFunds)
                : undefined;
        message.limitExceeded = (object.limitExceeded !== undefined && object.limitExceeded !== null)
            ? exports.TransferStatusTransferFailureLimitExceeded.fromPartial(object.limitExceeded)
            : undefined;
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseTransferStatusTransferFailureInsufficientFunds() {
    return { overflow: amount_1.Amount.fromPartial({}) };
}
exports.TransferStatusTransferFailureInsufficientFunds = {
    fromJSON(object) {
        const message = {
            overflow: isSet(object.overflow) ? amount_1.Amount.fromJSON(object.overflow) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.overflow !== undefined) {
            obj.overflow = amount_1.Amount.toJSON(message.overflow);
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferFailureInsufficientFunds.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatusTransferFailureInsufficientFunds();
        message.overflow = (object.overflow !== undefined && object.overflow !== null)
            ? amount_1.Amount.fromPartial(object.overflow)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseTransferStatusTransferFailureLimitExceeded() {
    return { limit: transaction_limit_error_1.TransactionLimitError.fromPartial({}) };
}
exports.TransferStatusTransferFailureLimitExceeded = {
    fromJSON(object) {
        const message = {
            limit: isSet(object.limit)
                ? transaction_limit_error_1.TransactionLimitError.fromJSON(object.limit)
                : transaction_limit_error_1.TransactionLimitError.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.limit !== undefined) {
            obj.limit = transaction_limit_error_1.TransactionLimitError.toJSON(message.limit);
        }
        return obj;
    },
    create(base) {
        return exports.TransferStatusTransferFailureLimitExceeded.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStatusTransferFailureLimitExceeded();
        message.limit = (object.limit !== undefined && object.limit !== null)
            ? transaction_limit_error_1.TransactionLimitError.fromPartial(object.limit)
            : transaction_limit_error_1.TransactionLimitError.fromPartial({});
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=transfer-status.js.map